export default __webpack_public_path__ + "img/2bba3901b88775de4b364a158284107c.png";